export default "__VITE_ASSET__BWrRVaVu__"